import { makeAutoObservable, runInAction } from 'mobx'
import { ChatbotApi, type IChatbotFullData } from 'entities/Chatbot'

export class AgentEditPreloadStore {
  data: IChatbotFullData | null = null
  error = false

  constructor() {
    makeAutoObservable(this)
  }

  load = async (id: number) => {
    try {
      const { data } = await ChatbotApi.getChatbot(id)
      runInAction(() => {
        this.data = data
      })
    } catch {
      runInAction(() => {
        this.error = true
      })
    }
  }
}
